<div class="error-container">
  <div class="error-content">
    <h1>Oops! Something went wrong</h1>
    <p>We're sorry, but something unexpected happened.</p>
    <button class="btn btn-primary" routerLink="/home">Go Home</button>
  </div>
</div>
